import { render, staticRenderFns } from "./videoPage.vue?vue&type=template&id=15fde6dd&scoped=true&"
import script from "./videoPage.vue?vue&type=script&lang=ts&"
export * from "./videoPage.vue?vue&type=script&lang=ts&"
import style0 from "./videoPage.vue?vue&type=style&index=0&id=15fde6dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fde6dd",
  null
  
)

export default component.exports